<surf-header class="l-page__header"></surf-header>

<div class="l-wrapper da-privacy-policy__container">
    <h3 class="item-title privacy-policy__head">PRIVACY POLICY
    </h3>

    <p><strong>Desert
        Adventures Tourism LLC</strong> (“<strong>DAT</strong>”) respects the privacy of its customers and
        is committed to the following privacy policy This Privacy Policy outlines what personal information DAT
        collects, whether via its website, the telephone or face to face, why it collects, how the same is used and
        is designed to give peace of mind and confidence and also describes the practices
        of <strong>DAT</strong> regarding the collection, use, disclosure, transfer, and other processing
        of individually identifiable information (“Personal Data”). We intend to process any Personal Data fairly,
        lawfully, and in accordance with applicable laws. Any collection, storage and processing of Personal Data
        will be conducted only in accordance with an appropriate consent that has been voluntarily, freely and
        explicitly provided, if and when required.</p>

    <h4>
        <strong> </strong>
    </h4>
    <h4>1. COLLECTION OF PERSONAL
        DATA</h4>
    <p> </p>
    <p>Throughout
        the course of conducting our business as a Destination Management Company, in dealing with
        Representatives, Partners, Suppliers, Clients, Guests of Partners Clients, industry peers and
        contacts, and potential Partners and/or Clients, we may collect and process Personal Data about you. We
        do not collect or process any Personal Data, and particularly sensitive Personal Data unless permitted
        and required by applicable law. If and to the extent permitted and required by applicable law, the
        Personal Information we collect and process <strong>may include</strong> the following
        categories:</p>
    <p> </p>
    <ul>
        <li>Personal Details: name; company name; country; email address; mobile telephone numbers; work
            address; work telephone numbers; web address data; IP address; instant messenger data
            (i.e. whatsapp, etc.); ethnicity; citizenship information; visa information; national and
            governmental identification information; drivers’ license information; passport information; bank
            details; birth date and birth place; and gender. If you choose to pay by credit/debit card we
            will also require these details, which will be destroyed once payment is taken.</li>
    </ul>
    <p> </p>
    <ul>
        <li>Related Persons Information: name and contact information of dependents or beneficiaries
            (including home address; home and work telephone numbers; mobile telephone numbers; date
            of birth; gender; emergency contacts; beneficiary information; dependent information).</li>
    </ul>
    <p> </p>
    <p> </p>
    <h4>2. METHODS OF COLLECTING
        PERSONAL DATA</h4>
    <p> </p>
    <p>We may
        collect Personal Data by the methods listed below:</p>
    <p> </p>
    <ul>
        <li>Exchanges of Business Cards during:
            <ul>
                <li>Business Meetings</li>
                <li>Exhibitions Events</li>
                <li>Networking events</li>
                <li>Sales Calls</li>
            </ul>
        </li>
    </ul>
    <p> </p>
    <ul>
        <li>Inquiry through:
            <ul>
                <li>Website</li>
                <li>Email</li>
                <li>Phone call</li>
                <li>Instant Messaging (i.e. whatsapp, etc)</li>
            </ul>
        </li>
    </ul>
    <p> </p>
    <ul>
        <li>Subscription to receive:
            <ul>
                <li>Newsletter</li>
                <li>Marketing Promotion emailers</li>
                <li>Corporate Updates Advisories</li>
                <li>Product Service Updates Advisories</li>
                <li>Direct E-mails</li>
                <li>Instant Messaging (i.e. whatsapp, etc., with expressed and explicit consent)</li>
                <li>Sales, Marketing Promotion collaterals</li>
            </ul>
        </li>
    </ul>
    <p>*Opt-Out: If you
        no longer wish to be contacted for marketing purposes, you can easily change your mind and withdraw such
        consent at any time by simply clicking the unsubscribe link in the footer of any email you receive from us.
        You may also do so by contacting us at&nbsp;
        <a href="mailto:sales@desertadventures.ae">sales@desertadventures.ae</a> or at
        <a href="mailto:marketing@desertadventures.ae">marketing@desertadventures.ae</a>.
    </p>
    <p> </p>
    <ul>
        <li>Business and/or Booking Contracts as:
            <ul>
                <li>Overseas Representative</li>
                <li>Partner</li>
                <li>Client</li>
                <li>Guest</li>
                <li>Supplier</li>
            </ul>
        </li>
    </ul>
    <p> </p>
    <ul>
        <li>Social Media Platforms (These may also be covered by separate Privacy Policies of each of the social
            media platforms)
            <ul>
                <li>Facebook</li>
                <li>twitter</li>
                <li>Instagram</li>
                <li>LinkedIn</li>
            </ul>
        </li>
    </ul>
    <p> </p>
    <ul>
        <li>Website Cookies</li>
    </ul>
    <p>*This
        website uses cookies. We use cookies to ensure that we give you the best experience on our website. You
        consent to our cookies if you continue to use our website.</p>
    <p> </p>
    <h4>3. INFORMATION ABOUT
        RELATED PERSONS</h4>
    <p> </p>
    <p>If you
        provide us with Personal Data about members of your family and/or dependents or beneficiaries (i.e. for
        booking consent on behalf of minor, emergency contacts, etc), it is your responsibility to
        inform them of their rights with respect to such information. You also are responsible for obtaining the
        explicit consent of these individuals (unless you can provide such consent on their behalf) to the
        processing (including transfer) of that Personal Data for the purposes set out in this Privacy Policy.
    </p>
    <p> </p>
    <h4>4. PURPOSES FOR
        COLLECTING PERSONAL DATA</h4>
    <p> </p>
    <p>DAT
        collects, processes, and otherwise uses your Personal Data for purposes that are required by applicable
        law, regulations, collective agreements or other contracts, to allow the Company to fulfil its business
        needs and legal obligations. These purposes include:</p>
    <p> </p>
    <ul>
        <li>Marketing Promotional activities, <strong>but subject to the willful and explicit
            provision of consent</strong>;</li>
        <li>Fulfilment of Contractual Obligation to deliver Products and Services (either to Representatives,
            Partners, Clients, Suppliers and/or Guests)</li>
        <li>Sales activities</li>
        <li>Supplier contracts</li>
        <li>Accounting Finance processes and procedures</li>
    </ul>
    <h4> </h4>
    <h4>5. DISCLOSURE AND
        SHARING OF PERSONAL DATA</h4>
    <p> </p>
    <p>Your
        Personal Data will be disclosed only to individuals within DAT who need access to your Personal Data to
        perform their duties for the purposes listed in Section 4 above or where required by applicable law.</p>
    <p> </p>
    <p>Within DAT,
        your Personal Data will be disclosed only to a limited number of restricted individuals, which may
        include marketing, sales, contracting, reservations, human resources, legal, finance, regulatory and
        compliance, accounting, compensation and benefit as well as certain managers to the extent any of these
        functions need access to your Personal Data in connection with their job responsibilities.</p>
    <p> </p>
    <p>DAT may also
        disclose your Personal Data to third parties providing information technology support or technical and
        organizational services ONLY in connection with the fulfilment of its business needs and legal
        obligations.</p>
    <p> </p>
    <p>DAT will
        exercise appropriate due diligence in the selection of its third party service providers, and require
        that they maintain adequate technical and organizational security measures to safeguard your
        Personal Data, and to process your Personal Data ONLY as instructed by DAT and for no other
        purposes.</p>
    <p> </p>
    <p>It is
        understood that your Personal Data will be disclosed to third parties only as necessary in connection
        with the performance of contracts, the Company’s business activities and the purposes listed in Section
        4 above, as permitted by consent or as otherwise authorized or permitted by the law.</p>
    <p> </p>
    <h4>6. INTERNATIONAL
        TRANSFER OF PERSONAL DATA</h4>
    <p> </p>
    <p>Due to the
        multinational character of DAT, some of the affiliated companies and other recipients listed in Section
        5 above may be located in countries (including the United States) that do not provide a level of data
        protection equivalent to that set forth by the law in your home country. DAT will take steps to make
        sure that such recipients act in accordance with applicable law and provide an adequate level of
        protection for your Personal Data including appropriate technical and organizational security measures,
        also through implementation of appropriate contractual measures to secure such transfer, in
        compliance with the applicable law.</p>
    <p> </p>
    <h4>7. DATA SECURITY</h4>
    <p> </p>
    <p>DAT
        maintains physical, technical, and organizational security measures to protect the Personal Data against
        accidental, unlawful, or unauthorized destruction, loss, alteration, disclosure, or access, whether it
        is processed in your local jurisdiction, the United States, or elsewhere. All the information you
        provide us through online systems is protected by a secure server. Any credit/debit card details will be
        destroyed once payment is made. We will never share your private details with anyone else, unless as
        specified above to facilitate your booking.</p>
    <p> </p>
    <h4>8. RETENTION AND
        ACCURACY OF PERSONAL DATA COLLECTED</h4>
    <p> </p>
    <p>DAT intends
        to keep your Personal Data accurate and up-to-date. We also strive to retain your Personal Data no
        longer than is necessary to carry out the purposes listed in this Privacy Policy or than required by
        law.</p>
    <p> </p>
    <p>Under
        applicable law, you have rights to: (i) check whether we hold Personal Data about you and to
        access such data; (ii) request correction of Personal Data about you that is inaccurate; and (iii)
        ascertain DAT policies and practices in relation to Personal Data. In certain circumstances, you also
        may have the right to object for legitimate reasons to the processing of your Personal Data in
        accordance with the applicable data protection regulations and to seek other legal remedies available to
        you in connection with the processing of your Personal Data. In fulfilment of your rights stated above,
        you may contact: <a href="mailto:sales@desertadventures.ae">sales@desertadventures.ae</a> and/or <a href="mailto:marketing@desertadventures.ae">marketing@desertadventures.ae</a>.
    </p>
    <h4>9. CHANGES TO THE
        NOTICE</h4>
    <p> </p>
    <p>Should we
        materially change our Personal Data practices or this Privacy Policy, we will issue an Advisory and/or
        take other steps in accordance with applicable laws, including seeking your consent to the
        modifications, where required by law.</p>
    <p> </p>
    <p> </p>
    <h4>10. QUESTIONS</h4>
    <p> </p>
    <p>If you have
        any questions about this Privacy Policy or wish to (i) access or review your Personal Data or learn more
        about who has access to your Personal Data, or (ii) make another type of request related to your
        Personal Data, please contact by email <a href="mailto: sales@desertadventures.ae">
            sales@desertadventures.ae</a> and/or <a href="mailto: marketing@desertadventures.ae.">
            marketing@desertadventures.ae.</a>. You may also contact us at tel.: +971 4 450 4450, fax: +971 4 450 4451.
    </p>

</div>


<surf-footer  class="l-page__footer" [version]="version"></surf-footer>